<template>
  <TableLayout :permissions="['business:transactions:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单编码（关联goodsorder)" prop="orderId">
        <el-input v-model="searchForm.orderId" placeholder="请输入订单编码（关联goodsorder)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户编码（关联member表）" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入用户编码（关联member表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易金额" prop="money">
        <el-input v-model="searchForm.money" placeholder="请输入交易金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易类型 0租车押金 1结算实际消费 2结算退款 3平台退款" prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入交易类型 0租车押金 1结算实际消费 2结算退款 3平台退款" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="preOrderid">
        <el-input v-model="searchForm.preOrderid" placeholder="请输入详细地址" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="onlineOrderid">
        <el-input v-model="searchForm.onlineOrderid" placeholder="请输入详细地址" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易完成时间" prop="doneDate">
        <el-input v-model="searchForm.doneDate" placeholder="请输入交易完成时间" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易标题" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入交易标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易内容" prop="content">
        <el-input v-model="searchForm.content" placeholder="请输入交易内容" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户当前余额(分）" prop="balance">
        <el-input v-model="searchForm.balance" placeholder="请输入用户当前余额(分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易关联对象类型 0订单 1退款单" prop="objType">
        <el-input v-model="searchForm.objType" placeholder="请输入交易关联对象类型 0订单 1退款单" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易关联对象编码" prop="objId">
        <el-input v-model="searchForm.objId" placeholder="请输入交易关联对象编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:transactions:create']">
        <li><el-button type="primary" @click="$refs.operaTransactionsWindow.open('新建交易流水表')" icon="el-icon-plus" v-permissions="['business:transactions:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="orderId" label="订单编码（关联goodsorder)" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="用户编码（关联member表）" min-width="100px"></el-table-column>
        <el-table-column prop="money" label="交易金额" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="交易类型 0租车押金 1结算实际消费 2结算退款 3平台退款" min-width="100px"></el-table-column>
        <el-table-column prop="preOrderid" label="详细地址" min-width="100px"></el-table-column>
        <el-table-column prop="onlineOrderid" label="详细地址" min-width="100px"></el-table-column>
        <el-table-column prop="doneDate" label="交易完成时间" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="交易标题" min-width="100px"></el-table-column>
        <el-table-column prop="content" label="交易内容" min-width="100px"></el-table-column>
        <el-table-column prop="balance" label="用户当前余额(分）" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="交易关联对象类型 0订单 1退款单" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="交易关联对象编码" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:transactions:update', 'business:transactions:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaTransactionsWindow.open('编辑交易流水表', row)" icon="el-icon-edit" v-permissions="['business:transactions:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:transactions:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaTransactionsWindow ref="operaTransactionsWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaTransactionsWindow from '@/components/business/OperaTransactionsWindow'
export default {
  name: 'Transactions',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaTransactionsWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        orderId: '',
        memberId: '',
        money: '',
        type: '',
        preOrderid: '',
        onlineOrderid: '',
        doneDate: '',
        title: '',
        content: '',
        balance: '',
        objType: '',
        objId: ''
      }
    }
  },
  created () {
    this.config({
      module: '交易流水表',
      api: '/business/transactions',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
